var _defs, _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMassConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M33.676 28.708a4.17 4.17 0 002.942-3.985V9.204a4.168 4.168 0 00-4.168-4.168H21.272c-1.092 0-2.087.42-2.83 1.108"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M7.34 19.032v-2.956c0-2.75 2.25-5 5-5h11.602c2.75 0 5 2.25 5 5v16.407c0 2.75-2.25 5-5 5H12.34c-2.75 0-5-2.25-5-5v-2.828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M13.219 24.82l2.849 2.848 7.007-7.008"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 7.346,
    cy: 24.503,
    r: 1.444
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMassConfirmation);
export default __webpack_public_path__ + "static/media/massConfirmation.fc6575c15b5652ad8ebdd2442df6ac1a.svg";
export { ForwardRef as ReactComponent };